import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  fetchAdminTranslationNamespaces,
  fetchAdminTranslations,
} from '@/api/(admin)/translations';
import type { AdminTranslationNamespace } from '@/api/(admin)/translations/types';
import type { TranslationRow, TranslationsQueryInput } from '../-types';
import {
  buildTranslationsQs,
  toTranslationRow,
  toTranslationsParams,
} from '../-utils/listParams';

export const adminTranslationsQueryKey = ['admin', 'translations'] as const;

export const adminTranslationNamespacesQueryOptions = queryOptions({
  queryKey: [...adminTranslationsQueryKey, 'namespaces'] as const,
  queryFn: fetchAdminTranslationNamespaces,
});

export function adminTranslationsQueryOptions(input: TranslationsQueryInput) {
  const params = toTranslationsParams(input);
  return queryOptions({
    queryKey: [...adminTranslationsQueryKey, 'list', params] as const,
    queryFn: () => fetchAdminTranslations(buildTranslationsQs(params)),
  });
}

export function useTranslationNamespaces() {
  const query = useQuery(adminTranslationNamespacesQueryOptions);
  const namespaces: AdminTranslationNamespace[] = query.data?.data ?? [];
  return { ...query, namespaces };
}

export function useAdminTranslations(input: TranslationsQueryInput) {
  const query = useQuery(adminTranslationsQueryOptions(input));
  const rows: TranslationRow[] = (query.data?.data ?? []).map(toTranslationRow);
  return { ...query, rows, totalCount: query.data?.meta?.totalCount ?? 0 };
}
